import { render, staticRenderFns } from "./FailureTable.vue?vue&type=template&id=4b70f074&scoped=true&"
import script from "./FailureTable.vue?vue&type=script&lang=js&"
export * from "./FailureTable.vue?vue&type=script&lang=js&"
import style0 from "./FailureTable.vue?vue&type=style&index=0&id=4b70f074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70f074",
  null
  
)

export default component.exports